import { Numerals, SimpleGenEq } from '../genHelper';
import { QEq } from '@educraft/base';

export class IVT__Binary__To16 extends SimpleGenEq {
  constructor() {
    super((data) => {
      const n = data.random.next(0, 16);
      return {
        text: `(${n.toString(2)})${Numerals.subScript(2)} =`,
        result: n,
      };
    }, 'IVT__Binary__To16');
  }
}

export class IVT__Binary__To256 extends SimpleGenEq {
  constructor() {
    super((data) => {
      const n = data.random.next(0, 256);
      return {
        text: `(${n.toString(2)})${Numerals.subScript(2)} =`,
        result: n,
      };
    }, 'IVT__Binary__To256');
  }
}

export class IVT__Hex__To16 extends SimpleGenEq {
  constructor() {
    super((data) => {
      const n = data.random.next(0, 16);
      return {
        text: `(${n.toString(16).toUpperCase()})${Numerals.subScript(16)} =`,
        result: n,
      };
    }, 'IVT__Hex__To16');
  }
}

export class IVT__Hex__To256 extends SimpleGenEq {
  constructor() {
    super((data) => {
      const n = data.random.next(0, 256);
      return {
        text: `(${n.toString(16).toUpperCase().padStart(2, '0')})${Numerals.subScript(16)} =`,
        result: n,
      };
    }, 'IVT__Hex__To256');
  }
}
